export default __webpack_public_path__ + "static/media/app-dev-icon.1214370b.png";